import React, { Component } from 'react';
import { Link, withRouter, } from 'react-router-dom';
import { auth } from '../../firebase';
import * as routes from '../../constants/routes';

const SignUpPage = ({ history }) =>
  <div>
    <h1>SignUp</h1>
    <SignUpForm history={history} />
  </div>

const INITIAL_STATE = {
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
};

class SignUpForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

   handleChange(e) {
      const target = e.target;
      const name = target.name;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      
      this.setState({
        [name]: value
      });
    }

  onSubmit (e) {
    e.preventDefault();
    
    const {
      email,
      passwordOne,
    } = this.state;

    auth.doCreateUser(email, passwordOne)
      .then(authUser => {

        this.props.history.push(routes.HOME);

      })
      .catch(error => {
        this.setState({error:error});
      });

  }

  render() {
    const {
      username,
      email,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      username === '' ||
      email === '';

    return (
      <form onSubmit={this.onSubmit}>
        <input name="username" value={username} onChange={this.handleChange} type="text" placeholder="Full Name"/>
        <input name="email" value={email} onChange={this.handleChange} type="text" placeholder="Email Address"/>
        <input name="passwordOne" value={passwordOne} onChange={this.handleChange} type="password" placeholder="Password"/>
        <input name="passwordTwo" value={passwordTwo} onChange={this.handleChange} type="password" placeholder="Confirm Password"/>
        <div className="button-footer">
          <button disabled={isInvalid}> Sign Up </button>
        </div>
        { error && <p>{error.message}</p> }
      </form>
    );
  }
}

const SignUpLink = () =>
  <p>
    Don't have an account?
    {' '}
    <Link to={routes.SIGN_UP}>Sign Up</Link>
  </p>

export default withRouter(SignUpPage);

export {
  SignUpForm,
  SignUpLink,
};


// WEBPACK FOOTER //
// ./src/components/Account/SignUp.js